import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import LoginInfo from '../login/LoginInfo';
import LogoImage from '../../../images/logo-image.png';
import Form from 'react-bootstrap/Form';
import Button from '../../../components/shared/buttons/button';
import { toast } from 'react-toastify';
import {useForgotPasswordMutation} from "../authApi";

const ForgetPassword = () => {
    const [email, setEmail] = useState('');
    const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            toast.error("Please enter your email address.");
            return;
        }

        try {
            await forgotPassword({ email }).unwrap();
            toast.success("A password reset email has been sent to your email address.");
            setEmail('');
           

        } catch (error) {
            console.error("Forgot Password Error:", error);
            if (error.status === 400 || error.status === 404) {
                toast.error(error.data.message || "Invalid Email or User not found.");
            } else if (error.data && error.data.message) {
                toast.error(error.data.message);
            }
            else {
                toast.error("An error occurred. Please try again later.");
            }
        }
    };

    return (
        <Row className='m-0'>
            
            <Col lg={6} className='p-0'>
                <div className='info_wrapper min-vh-100 d-flex justify-content-center align-items-center overflow-hidden position-relative'>
                    <LoginInfo />
                </div>
            </Col>
            <Col lg={6} className='p-0'>
                <div className='login_wrapper d-flex justify-content-center align-items-center min-vh-100'>
                    <div className='login_form'>
                        <div className='text-center pb-3'>
                            <img src={LogoImage} alt="logo" className='img-fluid' />
                        </div>
                        <h1 className='text-center'>Forget Password</h1>
                        <p className='text-center'>Enter the email associated with your account and <br/> 
                        we'll send you a link to rest your password
                        </p>
                        <Form onSubmit={handleSubmit}> {/* Add the form and onSubmit handler */}
                            <Form.Group className="mb-3 cmn_input">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <Button label="Send Email" size='medium' className="w-100" type="submit" loading={isLoading} /> {/* Submit button */}
                        </Form>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default ForgetPassword;